import { Injectable } from '@angular/core';
import { ServiceRepository } from '../service-repository';
import { Contactus, UseCase, ClientIndustry, ClientMarket, FileDownloadpath } from 'app/Shared/Model/contactus/contactus-model';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import { ErrorServiceService } from '../Error/error-service.service'
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class ContactusService {

  constructor(
    private _repositoryService: ServiceRepository,
    private _errorService: ErrorServiceService
  ) { }



  getUsecaseList(username: string): Observable<UseCase[]> {
    let params = new HttpParams();
    return this._repositoryService.getAll<UseCase[]>(
      '/api/ContactUs/GetUseCase/' + username, params)
      .pipe(
        map(data => data.map(data => new UseCase().deserialize(data)))            
      )

  }

  getClientMarketList(username: string): Observable<ClientMarket[]> {
    let params = new HttpParams();
    return this._repositoryService.getAll<ClientMarket[]>(
      '/api/ContactUs/GetClientMarket/' + username, params)
      .pipe(map(
        data => data.map(data => new ClientMarket().deserialize(data))
      )
      )
  }



  getClientIndustryList(username: string): Observable<ClientIndustry[]> {
    let params = new HttpParams();
    return this._repositoryService.getAll<ClientIndustry[]>(
      '/api/ContactUs/GetClientIndustry/' + username, params)
      .pipe(map(
        data => data.map(data => new ClientIndustry().deserialize(data))
      )      
      )

  }




  submitDetails(contactusdetails: Contactus) {    
    return this._repositoryService
      .createWithBody('/api/ContactUs/SubmitContactDetails', contactusdetails)
   

  }

  getFile(filepath: FileDownloadpath) {
    return this._repositoryService
      .downloadfile('/api/ContactUs/DownloadFile', filepath) 
  }

  getUserNameService() {
    return this._repositoryService
      .getDatawitHeaders('/UserRole/secret')    
  }


  


}
